/**
 * AUTOGENERATED - DO NOT EDIT DIRECTLY
 *
 * Please see "scripts/regionalization/README.md" for how to modify
 */

export enum ISOs {
  ARE = 'ARE',
  ATA = 'ATA',
  AUT = 'AUT',
  AUS = 'AUS',
  BHR = 'BHR',
  CAN = 'CAN',
  CHE = 'CHE',
  CZE = 'CZE',
  DEU = 'DEU',
  ESP = 'ESP',
  EGY = 'EGY',
  FRA = 'FRA',
  GBR = 'GBR',
  IRL = 'IRL',
  KOR = 'KOR',
  KWT = 'KWT',
  MAR = 'MAR',
  MYS = 'MYS',
  NLD = 'NLD',
  NZL = 'NZL',
  OMN = 'OMN',
  PHL = 'PHL',
  POL = 'POL',
  PRT = 'PRT',
  QAT = 'QAT',
  ROU = 'ROU',
  SAU = 'SAU',
  SGP = 'SGP',
  TWN = 'TWN',
  USA = 'USA',
  ZAF = 'ZAF',
  AE = 'ARE',
  AQ = 'ATA',
  AT = 'AUT',
  AU = 'AUS',
  BH = 'BHR',
  CA = 'CAN',
  CH = 'CHE',
  CZ = 'CZE',
  DE = 'DEU',
  ES = 'ESP',
  EG = 'EGY',
  FR = 'FRA',
  GB = 'GBR',
  IE = 'IRL',
  KR = 'KOR',
  KW = 'KWT',
  MA = 'MAR',
  MY = 'MYS',
  NL = 'NLD',
  NZ = 'NZL',
  OM = 'OMN',
  PH = 'PHL',
  PL = 'POL',
  PT = 'PRT',
  QA = 'QAT',
  RO = 'ROU',
  SA = 'SAU',
  SG = 'SGP',
  TW = 'TWN',
  US = 'USA',
  ZA = 'ZAF',
}

export enum RegionToISOs {
  AE = ISOs.ARE,
  AQ = ISOs.ATA,
  AT = ISOs.AUT,
  AU = ISOs.AUS,
  BH = ISOs.BHR,
  CA = ISOs.CAN,
  CH = ISOs.CHE,
  CZ = ISOs.CZE,
  DE = ISOs.DEU,
  ES = ISOs.ESP,
  EG = ISOs.EGY,
  FR = ISOs.FRA,
  GB = ISOs.GBR,
  IE = ISOs.IRL,
  KR = ISOs.KOR,
  KW = ISOs.KWT,
  MA = ISOs.MAR,
  MY = ISOs.MYS,
  NL = ISOs.NLD,
  NZ = ISOs.NZL,
  OM = ISOs.OMN,
  PH = ISOs.PHL,
  PL = ISOs.POL,
  PT = ISOs.PRT,
  QA = ISOs.QAT,
  RO = ISOs.ROU,
  SA = ISOs.SAU,
  SG = ISOs.SGP,
  TW = ISOs.TWN,
  US = ISOs.USA,
  ZA = ISOs.ZAF,
}

export enum ISOsToRegions {
  ARE = 'AE',
  ATA = 'AQ',
  AUT = 'AT',
  AUS = 'AU',
  BHR = 'BH',
  CAN = 'CA',
  CHE = 'CH',
  CZE = 'CZ',
  DEU = 'DE',
  ESP = 'ES',
  EGY = 'EG',
  FRA = 'FR',
  GBR = 'GB',
  IRL = 'IE',
  KOR = 'KR',
  KWT = 'KW',
  NLD = 'NL',
  NZL = 'NZ',
  MAR = 'MA',
  MYS = 'MY',
  OMN = 'OM',
  PHL = 'PH',
  POL = 'PL',
  PRT = 'PT',
  QAT = 'QA',
  ROU = 'RO',
  SAU = 'SA',
  SGP = 'SG',
  TWN = 'TW',
  USA = 'US',
  ZAF = 'ZA',
}
